// src/api/stripe.ts — browser → stripe edge functions
import { supabase } from '../supabase';
const base = () => import.meta.env.VITE_SUPABASE_URL + '/functions/v1';
async function authedFetch(path, body) {
    const { data } = await supabase.auth.getSession();
    const jwt = data?.session?.access_token ?? '';
    const r = await fetch(base() + path, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            authorization: `Bearer ${jwt}`,
            apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
        },
        body: JSON.stringify(body),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok)
        throw new StripeApiError(j?.error ?? 'upstream', j?.message ?? `Stripe call failed (${r.status}).`, r.status);
    return j;
}
export class StripeApiError extends Error {
    code;
    status;
    constructor(code, message, status) {
        super(message);
        this.code = code;
        this.status = status;
    }
}
export async function startCheckout(params) {
    return authedFetch('/stripe-checkout', params);
}
export async function openPortal(params) {
    return authedFetch('/stripe-portal', params);
}
